module.exports = __webpack_public_path__ + "static/media/new-hamburguer.ebfe19e5.svg";